import {Component} from '@angular/core';

@Component({
  selector: 'ax-components-theme',
  template: '<ng-content></ng-content>',
  styleUrls: ['components-theme.component.scss'],
})
export class ComponentsThemeComponent {}
